import { breakpoints } from '@theme/breakpoints';
import styled from 'styled-components';

export const StyledCoverageGridCard = styled.li``;
